var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{attrs:{"text":"","icon":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1),_c('PartnerDetail',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }